import { combineReducers } from 'redux';
import analysesVisits from '../slices/analysesVisits';
import builder from '../slices/oldBuilder';
import analyses from '../slices/analyses';
import collaboration from './collaboration';
import dashboardInstance from '../slices/dashboards/dashboardInstance';
import dashboardConfig from '../slices/dashboardConfig';
import incidents from './incidents';
import notifications from './notifications';
import loadingAnalyses from '../slices/loadingAnalyses';
import scheduler from './scheduler';
import auth from '../slices/auth';
import dictionary from '../slices/dictionary';
import bootstrap from '../slices/bootstrap';
import modal from '../slices/modal';
import workspaces from '../slices/workspaces';
import workspace from '../slices/workspace';
import executingAnalyses from '../slices/executingAnalyses';
import userSettings from '../slices/userSettings';
import cachedEntities from '../slices/cachedEntities';
import permission from '../slices/permission';
import dataModeler from '../slices/dataModeler';
import tiles from '../slices/tiles';
import llm from '../slices/llm';
import conversationThreads from '../slices/conversationThreads';

export default combineReducers({
  analysesVisits,
  builder,
  analyses,
  collaboration,
  dashboardInstance,
  dashboardConfig,
  incidents,
  notifications,
  loadingAnalyses,
  scheduler,
  auth,
  dictionary,
  bootstrap,
  modal,
  workspaces,
  workspace,
  executingAnalyses,
  userSettings,
  permission,
  cachedEntities,
  dataModeler,
  tiles,
  llm,
  conversationThreads,
});
